module.exports = __webpack_public_path__ + "static/media/no-posts-img.8e51d4f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-posts-img.svg
// module id = 140
// module chunks = 3